import { render, staticRenderFns } from "./ParentWidgetActive.vue?vue&type=template&id=75871e94&"
import script from "./ParentWidgetActive.vue?vue&type=script&lang=js&"
export * from "./ParentWidgetActive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports